import React from "react";
import DataGrid from '@dataGrid';
import PreviousMsgGridConfig from "./PreviousMsgGridConfig";
import { withStyles } from "@material-ui/core/styles";
import styles from "./PreviousMsgGridStyles";

const PreviousMsgGrid = ({
  classes,
  prevGroupMessageData,
  isDataLoaded,
  terminalOffset,
}) => {
  const { config } = new PreviousMsgGridConfig();
  return (
    <div className={classes.dataGrid}>
      <DataGrid
        defaultColDef={config.defaultColDef}
        columnDefs={config.columns}
        config={config}
        rowData={isDataLoaded ? prevGroupMessageData : null}
        getRowId={(params) => params.data.messageId}
        context={{terminalOffset}}
      />
    </div>
  );
};

export default withStyles(styles)(PreviousMsgGrid);
